<template>
	<div class="comp" style="position: relative;">
		<div class="compContent">
			<div class="content" >
				<div class="con">
					<div class="tabLine">
						<div class="tabLineL">
							<div class="tabItem" :class="[tabIndex===0?'active':'']" @click="changeTabIndex(0)">病例</div>
							<div class="tabItem" :class="[tabIndex===1?'active':'']" @click="changeTabIndex(1)">疫苗驱虫</div>
							<div class="tabItem" :class="[tabIndex===2?'active':'']" @click="changeTabIndex(2)">医疗服务</div>
						</div>
						<div class="tabLineR">
							
						</div>
					</div>
					<div v-if="tabIndex===0" class="elTable">
						<el-table :data="tableData0" style="width: 100%" height="100%">
							<el-table-column label="单号" prop="caseNumber">
							</el-table-column>
							<el-table-column label="宠物" prop="petName">
								<template slot-scope="props">
									{{props.row.petName}} | {{props.row.typeName}}
								</template>
							</el-table-column>
							<el-table-column label="创建时间" width="170">
								<template slot-scope="props">
									<div>{{$public.FTime(props.row.createTime)}}</div>
								</template>
							</el-table-column>
							<el-table-column label="医生" prop="doctorName"  width="100">
							</el-table-column>
							<el-table-column label="支付状态" width="80">
								<template slot-scope="props">
									<div style="color:#18A44C" v-if="props.row.isPay==true">已支付</div>
									<div style="color:#FD4E4E" v-else>未支付</div>
								</template>
							</el-table-column>
							<el-table-column label="是否出库" width="80">
								<template slot-scope="props">
									<div style="color:#18A44C" v-if="props.row.isOut">已出库</div>
									<div style="color:#B7B7B7" v-if="props.row.isOut==false">未出库</div>
								</template>
							</el-table-column>
							<el-table-column label="备注" prop="remark" width="120">
							</el-table-column>
							<el-table-column label="操作" width="200">
								<template slot-scope="props">
									<el-button type="text" size="mini" @click="toSee(props.row)">查看</el-button>
									<el-button type="text" size="mini" @click="toEdit(props.row)" v-if="props.row.isPay==true&&props.row.isOut===false">出库</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div v-if="tabIndex===1" class="elTable">
						<el-table :data="tableData1" style="width: 100%" height="100%" key="tableData1">
							<el-table-column label="单号" prop="serviceId" min-width="60">
							</el-table-column>
							<el-table-column label="宠物" prop="petName" min-width="70">
								<template slot-scope="props">
									{{props.row.petName}}
								</template>
							</el-table-column>
							<el-table-column label="类别" min-width="50">
								<template slot-scope="props">
									<div v-if="props.row.serviceTypeId===1">疫苗</div>
									<div v-if="props.row.serviceTypeId===2">驱虫</div>
								</template>
							</el-table-column>
							<el-table-column label="套餐名称" min-width="90" prop="servicePackageName">
							</el-table-column>
							<el-table-column label="计划名称" min-width="80" prop="planName">
							</el-table-column>
							<el-table-column label="实施计划" min-width="70" prop="planName">
								<template slot-scope="props">
									<div>
										<span>{{props.row.planIndex}}</span>/<span>{{props.row.planCount}}</span>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="计划时间" min-width="90">
								<template slot-scope="props">
									<div>{{$public.FTime(props.row.planDate,'YYYY-MM-DD')}}</div>
								</template>
							</el-table-column>
							<el-table-column label="添加人" min-width="60" prop="createUserName">
							</el-table-column>
							<el-table-column label="支付状态" min-width="70">
								<template slot-scope="props">
									<div style="color:#18A44C" v-if="props.row.isPay==true">已支付</div>
									<div style="color:#FD4E4E" v-else>未支付</div>
								</template>
							</el-table-column>
							<el-table-column label="是否出库" min-width="70">
								<template slot-scope="props">
									<div style="color:#18A44C" v-if="props.row.isOut">已出库</div>
									<div style="color:#B7B7B7" v-if="props.row.isOut===false">未出库</div>
								</template>
							</el-table-column>
							<el-table-column label="创建门店" min-min-width="70">
								<template slot-scope="props">
									<span v-if="props.row.shopId">{{$public.getShopNameById(props.row.shopId)}}</span>
								</template>
							</el-table-column>
							<el-table-column label="执行门店" min-width="70">
								<template slot-scope="props">
									<span v-if="props.row.currShopId">{{$public.getShopNameById(props.row.currShopId)}}</span>
								</template>
							</el-table-column>
							<el-table-column label="备注" prop="remark" min-width="50">
							</el-table-column>
							<el-table-column label="操作" min-width="90">
								<template slot-scope="props">
									<el-button type="text" size="mini" @click="toSee(props.row)">查看</el-button>
									<el-button type="text" size="mini" @click="toEdit(props.row)" v-if="props.row.isPay==true&&props.row.isOut===false&&props.row.planLock===false">出库</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div v-if="tabIndex===2" class="elTable">
						<el-table :data="tableData2" style="width: 100%" height="100%">
							<el-table-column label="单号" prop="id" width="90">
							</el-table-column>
							<el-table-column label="宠物" prop="petName">
								<template slot-scope="props">
									{{props.row.petName}}{{props.row.typeName}}
								</template>
							</el-table-column>
							<el-table-column label="类别" min-width="80">
							</el-table-column>
							<el-table-column label="套餐名称" min-width="180" prop="medicalServiceName">
							</el-table-column> 
							<el-table-column label="创建时间" min-width="150">
								<template slot-scope="props">
									<div>{{$public.FTime(props.row.createTime)}}</div>
								</template>
							</el-table-column>
							<el-table-column label="医生" prop="doctorName" min-width="80">
							</el-table-column>
							<el-table-column label="支付状态" min-width="80">
								<template slot-scope="props">
									<div style="color:#18A44C" v-if="props.row.isPay==true">已支付</div>
									<div style="color:#FD4E4E" v-else>未支付</div>
								</template>
							</el-table-column>
							<el-table-column label="是否出库" min-width="80">
								<template slot-scope="props">
									<div style="color:#18A44C" v-if="props.row.isOut">已出库</div>
									<div style="color:#B7B7B7" v-if="props.row.isOut===false">未出库</div>
								</template>
							</el-table-column>
							<el-table-column label="备注" prop="remark" min-width="100">
							</el-table-column>
							<el-table-column label="操作" min-width="90">
								<template slot-scope="props">
									<el-button type="text" size="mini" @click="toSee(props.row)">查看</el-button>
									<el-button type="text" size="mini" @click="toEdit(props.row)" v-if="props.row.isPay==true&&props.row.isOut===false">出库</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
		<div class="pageBox" style="position: absolute;bottom:-52px;width:100%;">
			<page style="padding:10px 0;" :total="page.total" :page="page.page" :pageSize="page.pageSize" @change="changePage"></page>
		</div>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	export default {
		components:{page},
		data(){
			return{
				tabIndex:0,
				
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData0:[],
				tableData1:[],
				tableData2:[],
			}
		},
		computed:{
			userInfo(){
				return this.$store.state.yiliaoxin.userInfo
			},
			platformParams(){
				return this.$store.state.yiliaoxin.platformParams;
			},
			yaofangParams(){
				return this.$store.state.yiliaoxin.yaofangParams;
			},
		},
		watch:{
			userInfo:{
				handler(n,o){
					if(n._id!==o._id){
						this.changePage(1)
					}
				},
				deep:true,
			}
		},
		created(){
			
		},
		mounted(){
			this.tabIndex = this.platformParams.initialDataOflist1.tabIndex||this.tabIndex;
			this.page = this.platformParams.initialDataOflist1.page||this.page;
			if(this.tabIndex===0){
				this.getTableData0();
			}else if(this.tabIndex===1){
				this.getTableData1();
			}else if(this.tabIndex===2){
				this.getTableData2();
			}
			
			this.yaofangParams.tabIndex = this.tabIndex
			this.yaofangParams.type = 'list'
			this.$store.commit("yiliaoxin/set_yaofangParams",this.yaofangParams)
		},
		methods: {
			changeTabIndex(index){
				this.tabIndex = index
				this.yaofangParams.tabIndex = index
				this.$store.commit("yiliaoxin/set_yaofangParams",this.yaofangParams)
				this.page.page = 1
				if(this.tabIndex===0){
					this.getTableData0();
				}else if(this.tabIndex===1){
					this.getTableData1();
				}else if(this.tabIndex===2){
					this.getTableData2();
				}
			},
			// 查看
			toSee(row){
				this.yaofangParams.curRow = row
				this.yaofangParams.type = 'see'
				this.$store.commit("yiliaoxin/set_yaofangParams",this.yaofangParams)
				this.$store.commit("yiliaoxin/set_curBusiness",'药房')
				this.$store.commit("yiliaoxin/add_router",{name:'药房',data:this.yaofangParams})
			},
			// 录入
			toEdit(row){
				this.yaofangParams.curRow = row
				this.yaofangParams.type = 'edit'
				this.$store.commit("yiliaoxin/set_yaofangParams",this.yaofangParams)
				this.$store.commit("yiliaoxin/set_curBusiness",'药房')
				this.$store.commit("yiliaoxin/add_router",{name:'药房',data:this.yaofangParams})
			},
			// 改变分页
			changePage(num){
				this.page.page = num;
				if(this.tabIndex===0){
					this.getTableData0();
				}else if(this.tabIndex===1){
					this.getTableData1();
				}else if(this.tabIndex===2){
					this.getTableData2();
				}
			},
			getTableData0(){
				if(this.$public.isNull(this.userInfo._id)){
					return
				}
				let params = {
					"departmentId": '', 
					"petId": "", 
					isPay:-1, // -1不限；0未支付；1已支付
					isOut:0,   // -1 0 1 2
					hasGoods:true,
					isInspect:-1,  // -1不限；0未检测；1已检测
					isVisit:-1,  // -1不限；0未回访；1已回访
					"desc": true, // true  倒序  false 正序
					"begin_time": "",
					"end_time": "",
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": '',
					memberId:this.userInfo._id,
					str:Math.random(),
				}
				let loading=this.$loading();
				this.$http.post('/api/Case/List', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.tableData0 = res.data.data;
						this.page.total = res.data.count;
						this.replaceRouter()
					}
				})
			},
			getTableData1(){
				if(this.$public.isNull(this.userInfo._id)){
					return
				}
				let params = {
					"serviceTypeId":0,  // 1疫苗；2驱虫; Default:0 
					"isPay": -1,          // -1 全部；0未支付；1已支付
					"petType": "",       //  猫类；犬类
					"status": 2,         // 1未完成；2已完成
					"isOut":0,        // 是否录入   -1：全部  0 1 2
					hasGoods:true,
					"desc": true,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": '',
					"memberId": this.userInfo._id,
					shopId:this.$store.state.shopId,
				}
				let loading=this.$loading();
				this.$http.post('/api/MedicalPackage/Plan/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData1 = res.data.data;
						this.page.total = res.data.count;
						this.replaceRouter()
					}
				})
			},
			getTableData2(){
				if(this.$public.isNull(this.userInfo._id)){
					return
				}
				let loading=this.$loading();
				let params = {
					"payType": 0, // 1全额；2消费卡
					"isPay": -1,  // -1全部；0未支付；1已支付  
					"isOut":0,        // 是否录入    -1 全部 0 1 2
					serviceStatus:2,  // 2：已完成
					hasGoods:true,
					"petType": "",    // 猫类；犬类
					"petId": "",
					"desc": true,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword":'',
					"memberId": this.userInfo._id,
				}
				this.$http.post('/api/MedicalService/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData2 = res.data.data;
						this.page.total = res.data.count;
						this.replaceRouter()
					}
				})
			},
			replaceRouter(){
				this.platformParams.initialDataOflist1 = {
					tabIndex:this.tabIndex,
					page:this.page,
				}
				this.$store.commit("yiliaoxin/set_platformParams",this.platformParams)
				this.$store.commit("yiliaoxin/replace_router",{name:'工作台',data:JSON.parse(JSON.stringify(this.platformParams))})
			},
		},
		// beforeDestroy(){
		// 	this.platformParams.initialDataOflist1 = {
		// 		tabIndex:this.tabIndex,
		// 		page:this.page,
		// 	}
		// 	this.$store.commit("yiliaoxin/set_platformParams",this.platformParams)
		// },
	}
</script>
<style scoped lang="scss">
	.comp{
		position: relative;height: 100%;box-sizing: border-box;
		.compContent{
			height: 100%;width:100%;background-color: #fff;border-radius: 12px;overflow: auto;
			.title{
				display: flex;height: 47px;line-height: 27px;border-bottom:1px solid #f2f2f2;padding:10px 18px;box-sizing: border-box;
				.titleL{
					width:50%;font-size: 14px;font-weight: bold;
				}
				.titleR{
					width:50%;text-align: right;
					.titleRText{
						display: inline-block;font-size: 14px;color:$mainColor;margin-left: 40px;cursor: pointer;
					}
				}
			}
			.content{
				position: relative;display: flex;width:100%;height: 100%;box-sizing: border-box;
				.con{
					width:100%;
					.tabLine{
						height:60px;padding:16px 20px 12px;box-sizing: border-box;display: flex;justify-content: space-between;
						.tabLineL{
							display: flex;
							.tabItem{
								width:90px;text-align: center;line-height: 32px;border-radius: 19px;background-color: #f7f7f7;color:#73737B;font-size: 14px;margin-right: 20px;border:1px solid transparent;cursor: pointer;
								font-weight: bold;
								&.active{
									color:$mainColor;background-color: #FFF9F3;border-color:$mainColor;
								}
							}
						}
						.tabLineR{
							
						}
					}
					.searchLine{
						padding:8px 20px 20px;box-sizing: border-box;display: flex;
						.searchLineL{
							display: flex;
							.searchLabel{
								font-size: 12px;color:$fontColor;line-height:32px;margin-left:10px;
							}
						}
						.searchLineR{
							
						}
					}
					.elTable{
						height: calc(100% - 60px);
					}
				}
				.pageBox{
					position: absolute;bottom:0;width:100%;
				}
			}
		}
	}
</style>
